export function isSymbol(key) {
  if (!key || key.length > 1) return false;

  return /[a-zA-Z0-9-_ ]/.test(key);
}

export function isBackspace(key) {
  return key && key.toLowerCase() === "backspace";
}
